import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove injected badge
const removeBadge = () => {
  const el = document.getElementById('emergent-badge');
  if (el) el.remove();
};
removeBadge();
new MutationObserver(removeBadge).observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
